"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeClass = exports.Modal = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Heading = require("b2b-components/core/components/Modal/Heading");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _ModalContainer = require("./ModalContainer.types");
require("./Modal.scss");
const typeClass = exports.typeClass = {
  [_ModalContainer.MODAL_TYPE.default]: '',
  [_ModalContainer.MODAL_TYPE.fullscreen]: 'cds-Modal-Type--Fullscreen',
  [_ModalContainer.MODAL_TYPE.leftSide]: 'cds-Modal-Type--LeftSide',
  [_ModalContainer.MODAL_TYPE.rightSide]: 'cds-Modal-Type--RightSide',
  [_ModalContainer.MODAL_TYPE.small]: 'cds-Modal-Type--Small',
  [_ModalContainer.MODAL_TYPE.process]: 'cds-Modal-Type--Process'
};
const Modal = _ref => {
  let {
    content,
    dataAttributes,
    modalRef,
    onClickAway,
    onClose,
    onKeyDown,
    title,
    type,
    hideCloseButton,
    className,
    transitionClassName
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-ModalCover', transitionClassName);
  const modalClassName = (0, _classnames.default)('cds-Modal', typeClass[type], {
    ['cds-Modal-Animation--SlideLeft']: type === _ModalContainer.MODAL_TYPE.leftSide,
    ['cds-Modal-Animation--SlideRight']: type === _ModalContainer.MODAL_TYPE.rightSide
  }, className);
  const body = document.body;
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("aside", {
    "aria-modal": "true",
    className: rootClassName,
    onKeyDown: onKeyDown,
    onMouseDown: onClickAway,
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: modalClassName,
    ref: modalRef
  }), /*#__PURE__*/_react.default.createElement(_Heading.Heading, {
    title: title,
    onClose: onClose,
    hideCloseButton: hideCloseButton
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Modal-Content"
  }, content))), body);
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map